export default __webpack_public_path__ + "static/media/image.5f1f2437.png";